import { CampoFormik } from '../../../components/CompUtils';
import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form } from 'react-bootstrap';
import * as yup from 'yup';
import es from '../../../yup-es';
import bsCustomFileInput from 'bs-custom-file-input';
import Dialog from '../../../components/CompUtils/Dialog';
import { useDispatch } from 'react-redux';
import { crearNuevoConcurso, fetchEnProgreso } from './gestionConcursoSlice';
import ErrorMsg from '../../../components/CompUtils/ErrorMsg';
import { setNotification } from '../../../components/GlobalFeedback/feedbackSlice';

const NuevoConcurso = ({ onCloseCallback, show, size = 'md' }) => {
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState('');

  const handleClose = () => {
    onCloseCallback();
    setErrorMsg('');
  };

  const handleSubmit = (values) => {
    const conData = {
      datos: {
        cantCargosReserva: values.cantCargosReserva,
        cantCargosSinReserva: values.cantCargosSinReserva,
        descripcion: values.descripcion,
        idOrganismo: values.idOrganismo,
        idTipoConcurso: values.idTipoConcurso,
        nroExpedienteAsignacion: values.nroExpedienteAsignacion,
        nroIfIntervencionDsps: values.nroIfIntervencionDsps,
        nroInfSolAsignacionVacante: values.nroInfSolAsignacionVacante,
        nroProda: values.nroProda,
      },
      documentoProda: values.documentoProda,
      documentoDenominacionPuesto: values.documentoDenominacionPuesto,
    };

    dispatch(crearNuevoConcurso({ data: conData }))
      .then((res) => {
        handleClose();
        dispatch(fetchEnProgreso()).then((res) => {
          dispatch(
            setNotification({
              variant: 'success',
              msg: 'Nueva convocatoria generada exitosamente.',
            }),
          );
        });
      })
      .catch((error) => {
        if (error.response) {
          setErrorMsg(error.response.data.message);
        } else if (error.request) {
          setErrorMsg(error.request.message);
        } else {
          setErrorMsg(error.message);
        }

        throw error;
      });
  };
  return (
    <Dialog
      backdrop="static"
      title="Asignación de vacantes"
      size={size}
      show={show}
      handleClose={handleClose}
      footer={
        <>
          <ErrorMsg msg={errorMsg} />
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" type="submit" form="nuevoConcursoForm">
            Confirmar
          </Button>
        </>
      }>
      <NuevoConcursoForm onSubmit={handleSubmit} />
    </Dialog>
  );
};

export const NuevoConcursoForm = ({ onSubmit }) => {
  useEffect(() => {
    bsCustomFileInput.init();
  }, []);

  yup.setLocale(es);
  const schema = yup.object({
    idJurisdiccion: yup.number(),
    idOrganismo: yup.number().required(),
    idTipoConcurso: yup.number().required(),
    nroExpedienteAsignacion: yup.string().required(),
    nroIfIntervencionDsps: yup.string().required(),
    nroInfSolAsignacionVacante: yup.string().required(),
    cantCargosReserva: yup.number().required(),
    cantCargosSinReserva: yup.number().required(),
    total: yup.number().required().positive(),
    // descripcion: yup.string(),
    documentoProda: yup
      .mixed()
      .test('required', 'Seleccione un archivo a cargar', (value) => !!value.name),
    nroProda: yup.string().required(),
    documentoDenominacionPuesto: yup
      .mixed()
      .test('required', 'Seleccione un archivo a cargar', (value) => !!value.name),
  });

  const initialValues = {
    nroExpedienteAsignacion: '',
    nroIfIntervencionDsps: '',
    nroInfSolAsignacionVacante: '',
    // descripcion: '',
    idTipoConcurso: 1,
    idJurisdiccion: '',
    idOrganismo: '',
    cantCargosReserva: '',
    cantCargosSinReserva: '',
    total: '',
    nroProda: '',
    documentoProda: {},
    documentoDenominacionPuesto: {},
  };

  const handleSubmit = (values, action) => {
    onSubmit && onSubmit(values);
  };

  const handleSinReserva = (ev, formik) => {
    const sinReserva = parseInt(ev.currentTarget.value) || 0;
    const conReserva = parseInt(formik.values.cantCargosReserva) || 0;
    formik.handleChange(ev);
    formik.setFieldValue('total', sinReserva + conReserva);
  };
  const handleConReserva = (ev, formik) => {
    const conReserva = parseInt(ev.currentTarget.value) || 0;
    const sinReserva = parseInt(formik.values.cantCargosSinReserva) || 0;
    formik.handleChange(ev);
    formik.setFieldValue('total', sinReserva + conReserva);
  };

  return (
    <Container fluid>
      <Formik
        validationSchema={schema}
        validateOnChange={false}
        initialValues={initialValues}
        onSubmit={handleSubmit}>
        {(formik) => (
          <Form noValidate onSubmit={formik.handleSubmit} id="nuevoConcursoForm">
            <Form.Row>
              <CampoFormik
                name="idJurisdiccion"
                label="Jurisdicción"
                type="jurisdiccion"
                formik={formik}
              />
              <CampoFormik
                type="organismo"
                jurisdiccion={formik.values.idJurisdiccion}
                label="Organismo *"
                name="idOrganismo"
                formik={formik}
              />
            </Form.Row>
            <Form.Row>
              <CampoFormik
                col={{ sm: 6 }}
                type="select"
                label="Tipo de convocatoria *"
                name="idTipoConcurso"
                formik={formik}>
                <option value="1">Interna</option>
                <option value="2">Abierta</option>
                <option value="3">General</option>
              </CampoFormik>
            </Form.Row>
            <Form.Row>
              <CampoFormik
                name="nroExpedienteAsignacion"
                label="N° expediente asignación (Carátula exp.) *"
                formik={formik}
              />
              <CampoFormik
                name="nroInfSolAsignacionVacante"
                label="Informe solicitud asignación vacantes *"
                formik={formik}
              />
            </Form.Row>
            <Form.Row></Form.Row>
            <Form.Row>
              <CampoFormik
                name="nroIfIntervencionDsps"
                col={{ sm: 6 }}
                label="N° de IF intervención DSPS *"
                formik={formik}
              />
            </Form.Row>
            <Form.Row>
              <CampoFormik name="nroProda" label="N° de RESO/DA *" formik={formik} />
              <Form.Group as={Col} sm={6}>
                <Form.Label>Proyecto Acto Administrativo (PRODA) *</Form.Label>
                <Form.File id="documentoProda" custom>
                  <Form.File.Input
                    name="documentoProda"
                    accept=".pdf,.doc,.odt,.jpg,.png"
                    type="file"
                    isInvalid={formik.touched.documentoProda && !!formik.errors.documentoProda}
                    onChange={(ev) => {
                      formik.setFieldValue('documentoProda', ev.currentTarget.files[0]);
                    }}
                  />
                  <Form.File.Label data-browse="Cargar archivo">
                    Seleccione un archivo
                  </Form.File.Label>
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.documentoProda}
                  </Form.Control.Feedback>
                </Form.File>
              </Form.Group>
            </Form.Row>
            <Form.Row></Form.Row>
            {/* <Form.Row>
              <CampoFormik label="Descripcion" name="descripcion" type="textarea" formik={formik} />
            </Form.Row> */}
            <Form.Row>
              <Form.Group as={Col} sm={6}>
                <Form.Label>Denominación de Cargos *</Form.Label>
                <Form.File id="denominacionCargos" custom>
                  <Form.File.Input
                    name="documentoDenominacionPuesto"
                    accept=".pdf,.doc,.odt,.jpg,.png"
                    type="file"
                    isInvalid={
                      formik.touched.documentoDenominacionPuesto &&
                      !!formik.errors.documentoDenominacionPuesto
                    }
                    onChange={(ev) => {
                      formik.setFieldValue(
                        'documentoDenominacionPuesto',
                        ev.currentTarget.files[0],
                      );
                    }}
                  />
                  <Form.File.Label data-browse="Cargar archivo">
                    Seleccione un archivo
                  </Form.File.Label>
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.documentoDenominacionPuesto}
                  </Form.Control.Feedback>
                </Form.File>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <CampoFormik
                col={{ sm: 3 }}
                name="cantCargosSinReserva"
                label="Cargos Sin Reserva*"
                size="2"
                formik={formik}
                style={{ width: '4rem' }}
                onChange={(ev) => handleSinReserva(ev, formik)}
              />
              <CampoFormik
                col={{ sm: 3 }}
                name="cantCargosReserva"
                label="Cargos Con Reserva*"
                size="2"
                formik={formik}
                style={{ width: '4rem' }}
                onChange={(ev) => handleConReserva(ev, formik)}
              />
              <CampoFormik
                col={{ sm: 3 }}
                isInvalid={false}
                name="total"
                label="Total de cargos"
                size="2"
                formik={formik}
                style={{ width: '4rem' }}
                readOnly
              />
            </Form.Row>
          </Form>
        )}
      </Formik>
    </Container>
  );
};

export default NuevoConcurso;
